export default __webpack_public_path__ + "static/media/ea-girl.6fa36006.webp";